import { valueTokens } from "../../designTokens";
import type { Theme } from "../types/theme";

export const lightTheme: Theme = {
  // Typography
  "--text-primary": valueTokens.$gray300,
  "--text-secondary": valueTokens["$black65%"],
  "--text-black": valueTokens.$gray300,
  "--text-white": valueTokens.$beige100,
  "--text-inverted": valueTokens.$beige100,
  "--text-logo": valueTokens.$green500,

  // Background
  "--background-primary": valueTokens.$beige100,
  "--background-secondary": valueTokens.$white,
  "--background-tertiary": valueTokens.$white,
  "--background-inverted": valueTokens.$gray500,
  "--background-white": valueTokens.$white,
  "--surface-neutral": valueTokens.$beige200,

  // Border and dividers
  "--border-distinct": valueTokens.$beige400,
  "--border-subtle": valueTokens.$beige200,
  "--border-subtle-non-darkmode": valueTokens.$beige200,
  "--border-input": valueTokens.$beige500,

  // Buttons & Links
  "--button-primary": valueTokens.$green400,
  "--button-border": valueTokens["$black65%"],
  "--button-dismissive": valueTokens.$red400,
  "--link-primary": valueTokens.$green400,

  // Status
  "--active-highlight": valueTokens.$green400,
  "--notification": valueTokens.$amber400,
  "--surface-success": valueTokens.$green150,
  "--on-surface-success": valueTokens.$green500,
  "--surface-highlight": valueTokens.$amber150,
  "--on-surface-highlight": valueTokens.$amber500,
  "--surface-info": valueTokens.$indigo150,
  "--on-surface-info": valueTokens.$indigo500,
  "--surface-shared": valueTokens.$brown100,
  "--on-surface-shared": valueTokens.$amber500,
  "--error-text": valueTokens.$red400,
  "--surface-error-light": valueTokens.$red100,
  "--on-surface-error-light": valueTokens.$red400,

  // Disabled
  "--surface-disabled": valueTokens.$beige300,
  "--on-surface-disabled": valueTokens["$black50%"],
  "--border-disabled": valueTokens.$beige400,

  // States
  "--hover-background": valueTokens.$beige150,
  "--button-primary-hover": valueTokens.$green450,
  "--button-dismissive-hover": valueTokens.$red500,
  "--button-filled-hover": valueTokens.$white,
  "--link-primary-hover": valueTokens.$green450,
  "--focus-border": valueTokens.$green500,

  // Greens
  "--green-100": valueTokens.$green100,
  "--green-150": valueTokens.$green150,
  "--green-200": valueTokens.$green200,
  "--green-300": valueTokens.$green300,
  "--green-400": valueTokens.$green400,
  "--green-500": valueTokens.$green500,

  // Amber
  "--amber-100": valueTokens.$amber100,
  "--amber-200": valueTokens.$amber200,
  "--amber-300": valueTokens.$amber300,
  "--amber-400": valueTokens.$amber400,
  "--amber-500": valueTokens.$amber500,

  // Indigo
  "--indigo-100": valueTokens.$indigo100,
  "--indigo-200": valueTokens.$indigo200,
  "--indigo-300": valueTokens.$indigo300,
  "--indigo-400": valueTokens.$indigo400,
  "--indigo-500": valueTokens.$indigo500,

  // Kivra Extra
  "--kvx-sand100": valueTokens.$kvxSand100,
  "--kvx-sand200": valueTokens.$kvxSand200,
  "--kvx-gradient01": valueTokens.$kvxGradient01,

  // Box shadow
  "--shadow-raised": `0px 2px 8px ${valueTokens["$black6%"]}`,
  "--shadow-floating": `0px 8px 16px ${valueTokens["$black8%"]}`,
  "--shadow-hover-list": `0px 0px 12px ${valueTokens["$black6%"]}`,
};
